<!--
  - Copyright (c) 2020.
  - Project: Source
  - LastModified: 2/14/20, 3:23 PM
  - Author: diengv < Giáp Văn Điện >
  - Email: diengv@ominext.com
  - File name: Home.vue
  - File path: D:/Projects/PMS/Source/Client/vuejs/src/resources/views/Home.vue
  -->

<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/img/logo.png">
  </div>
</template>

<script>

export default {
  name: 'home',
}
</script>
